import { css } from "lit";

export const defaultTokens = css`
  :host {
    --cg-bg: #ffffff;
    --cg-surface: rgba(255, 255, 255, 0.95);
    --cg-text: #111827;
    --cg-muted: rgba(17, 24, 39, 0.65);
    --cg-border: rgba(17, 24, 39, 0.12);

    --cg-primary: #111827;
    --cg-on-primary: #ffffff;

    --cg-radius: 24px;
    --cg-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 2px 10px rgba(0, 0, 0, 0.1);

    --cg-font: "Inter", sans-serif;
  }
`;

export const lightTokens = `
:host {
  --cg-bg: #ffffff;
  --cg-surface: rgba(255,255,255,0.94);
  --cg-text: #111827;
  --cg-muted: rgba(17,24,39,0.6);
  --cg-border: rgba(17,24,39,0.12);

  --cg-radius: 24px;
  --cg-shadow: 0 10px 40px rgba(0,0,0,0.15), 0 2px 10px rgba(0,0,0,0.1);
}
`;

export const darkTokens = `
:host {
  --cg-bg: #0b0f19;
  --cg-surface: rgba(18,24,38,0.92);
  --cg-text: #f9fafb;
  --cg-muted: rgba(249,250,251,0.55);
  --cg-border: rgba(255,255,255,0.14);

  --cg-radius: 24px;
  --cg-shadow: 0 10px 40px rgba(0,0,0,0.4), 0 2px 10px rgba(0,0,0,0.2);
}
`;
